import React from 'react';
import { Icon, ICON_NAMES } from "../Icon";
export var getTriggerMarkup = function getTriggerMarkup(size) {
  return React.createElement(Icon, {
    color: "grey",
    isCircular: true,
    isColorInverted: true,
    name: ICON_NAMES.INFO,
    size: size
  });
};